import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PersonIcon from '@material-ui/icons/Person';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';

import RestrictionsForm from '../../Employee/components/Forms/RestrictionsForm';
import { createNewEmployee } from '../../../store/actions/employee';
import CustomPopper from '../../../components/Popper/CustomPopper';
import Star from '@material-ui/icons/Star';

function RestrictionsConfig(props) {
  const dispatch = useDispatch();

  function onUpdateEmpoyee(data) {
    // console.log('DATA',moment(data.dtRef).format('YYYY-MM-DD'))
    const restrictions = {
      employees: props.employee,
      restrictions: {
        dtRef: moment(data.dtRef).format('YYYY-MM-DD') == 'Data inválida' ? moment(new Date()).format('YYYY-MM-DD') : moment(data.dtRef).format('YYYY-MM-DD'),
        hasPhoto: data.hasPhoto,
        restrictByLocation: data.restrictByLocation,
        hasBlockedDevice: props.state.newHasBlockedDevice == '' ? null : props.state.newHasBlockedDevice
      },
      allowedLocations: data.locations,
    };
    // console.log('data',restrictions.restrictions)
    dispatch(createNewEmployee(restrictions, 'Atualização realizada com sucesso'))
      .then(() => props.close());
  }
  const employeesSelected = props.employees.filter(employee => props.employee.includes(employee.id));
  const employeeNames = employeesSelected.map(employee => ` ${employee.name}`).toString();
  const premium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;

  return (
    <div>

      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {!premium ?
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}>
              Configurar Restrições<Star style={{ color: '#f2b002' }} />
            </div>
            :
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}>
              Configurar Restrições
            </div>
          }
        </DialogTitle>
        <DialogContent>
          <div style={{
            display: 'flex', alignItems: 'center', marginBottom: '24px', marginLeft: '5px',
          }}
          >
            <PersonIcon
              style={{
                backgroundColor: '#537ccd',
                color: 'white',
                borderRadius: '50%',
                fontSize: '34px',
                padding: '4px',
              }}
            />
            <div style={{ marginRight: 'auto', marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
              {employeeNames.length > 90 ? (
                <>
                  <span>{`${employeeNames.slice(0, 90)}...`}</span>
                  <CustomPopper
                    element={onClick => (
                      <IconButton aria-label="Mostrar detalhes" size="small" onClick={onClick} style={{ padding: '4px' }}>
                        <ArrowDown />
                      </IconButton>
                    )}
                    content={employeeNames}
                  />
                </>
              ) : <span>{employeeNames}</span>}
            </div>
          </div>
          <RestrictionsForm
            handleNewHasBlockedDevice={props.handleNewHasBlockedDevice}
            state={props.state.newHasBlockedDevice}
            data={props.data || []}
            updateEmployee={onUpdateEmpoyee}
            loading={false}
            title="Cadastrar"
            locations={props.locations}
            hasBlockedDevice={props.data.hasBlockedDevice}
            innerSubmit
            close={props.close}
          />
        </DialogContent>
      </Dialog>

    </div>
  );
}

export default RestrictionsConfig;

